import { useCallback } from 'react';
import { useSignupNavigation } from '../hooks/useSignupNavigation';
import { LAST_SCREENING_STEP } from './screening-steps';

/**
 * The one way out of TAPS 2: replace to the step after the segment (the start
 * of wrap-up). Every exit, answered or passed through, goes through here, so
 * work that must run when the member leaves the quiz has a single place to
 * attach.
 */
export function useLeaveScreening(): () => void {
  const { goToNextStep } = useSignupNavigation();
  return useCallback(() => goToNextStep(LAST_SCREENING_STEP), [goToNextStep]);
}
